import { api } from "./api";

export type ProductEventType =
  | "signup_completed"
  | "game_started"
  | "game_finished"
  | "placement_game_finished"
  | "first_game_started"
  | "first_game_finished"
  | "joined_league"
  | "opened_game_review"
  | "subscribed"
  | "review_practice_checked"
  | "mistake_practice_offered"
  | "practice_next_action"
  | "page_view";

export async function trackEvent(type: ProductEventType, metadata?: any) {
  try {
    // We send to our internal API
    await api.post("/admin/track", {
      type,
      metadata: metadata ? JSON.stringify(metadata) : null,
      timestamp: new Date().toISOString(),
    });

    // Note: We could also call ym() or gaEvent() here if we want a single entry point
  } catch (e) {
    console.error("Failed to track event", e);
  }
}
